import type { ComponentInternalInstance } from 'vue'

export const formKey = Symbol('_b_form_') as InjectionKey<{
  bindComponent: (component: ComponentInternalInstance) => void
  unbindComponent: (component: ComponentInternalInstance) => void
}>

export type FormRule = ((v: any) => true | string)
export type FormRules = FormRule[]
